import { ApiPath } from "enums";
import { Get } from "utils";

export const getLubeServBookings = async ({ ...query }) => {
  const res = await Get(`${ApiPath.GetBooking}`, { ...query });
  return res.data;
};
